module.exports = __webpack_public_path__ + "img/img_siyouyun.14d7ec3b.png";